import toIcon from '../toIcon';
import svg from './facebook.svg';

export default toIcon(svg, { margin: '0 -.04em' });
